import * as React from 'react';
import { sortBasedOnList } from '../utils';

export type Table16Data = { [key: string]: Table16Row };

export interface ITable16Props {
  data: Table16Data;
}

interface ITable16State {
}

export interface Table16Row {
  fatal: number;
  injuryA: number;
  injuryB: number;
  injuryC: number;
  pdo: number;
  total: number;
}

const sortOrder = [
  "Dry",
  "Ice/Frost",
  "Mud, Dirt, Gravel",
  "Oil",
  "Sand",
  "Slush",
  "Snow",
  "Water (standing, moving)",
  "Wet",
  "Other",
  "Unknown",
  "Not Stated",
];

export default class Table16Summary extends React.Component<ITable16Props, ITable16State> {
  constructor(props: ITable16Props) {
    super(props);
  }

  componentDidMount = function () {
  }

  public render() {
    return (
      <React.Fragment>
        {this.props.data ?
          <table className="ss-table summaryTable1">
            <colgroup>
              <col style={{ width: '50%' }} />
              <col span={6} style={{ width: '8.3%' }} />
            </colgroup>
            <thead>
              <tr>
                <th rowSpan={2} className="border-right-bold">
                  <div className="ss-table-header">
                    <span className="header-number">16</span>
                    {/* <div style={{ width: '3px', height: '100px', backgroundColor: 'black' }} /> */}
                    <span className="header-text">ROAD SURFACE CONDITION</span>
                  </div>
                </th>
                <th rowSpan={2}>TOTAL</th>
                <th rowSpan={2}>FATAL</th>
                <th colSpan={3}>INJURY</th>
                <th rowSpan={2}>PDO **</th>
              </tr>
              <tr>
                <th>A*</th>
                <th>B*</th>
                <th>C*</th>
              </tr>
            </thead>
            <tbody>
              {sortBasedOnList(this.props.data, sortOrder).map((key) =>
                <tr key={key}>
                  <td className="border-right-bold">{key}</td>
                  <td className="numberTotals">{this.props.data[key].total}</td>
                  <td className="numberTotals">{this.props.data[key].fatal}</td>
                  <td className="numberTotals">{this.props.data[key].injuryA}</td>
                  <td className="numberTotals">{this.props.data[key].injuryB}</td>
                  <td className="numberTotals">{this.props.data[key].injuryC}</td>
                  <td className="numberTotals">{this.props.data[key].pdo}</td>
                </tr>
              )}
            </tbody>
          </table>
          : <p>Loading...</p>}
      </React.Fragment>
    );
  }
}
